var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgHeadphones = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor',
    fillRule: "evenodd",
    d: "M2.25,18.9999999 L2.25,11.9999999 C2.25,6.6152236 6.61522375,2.25 12,2.25 C17.3847763,2.25 21.75,6.6152236 21.75,11.9999999 L21.75,18.9999999 C21.75,20.5187829 20.5187831,21.75 19,21.75 L18,21.75 C16.4812169,21.75 15.25,20.5187829 15.25,18.9999999 L15.25,15.9999999 C15.25,14.4812168 16.4812169,13.25 18,13.25 L20.25,13.25 L20.25,11.9999999 C20.25,7.44365074 16.5563491,3.75 12,3.75 C7.44365086,3.75 3.75,7.44365074 3.75,11.9999999 L3.75,13.25 L6,13.25 C7.51878306,13.25 8.75,14.4812168 8.75,15.9999999 L8.75,18.9999999 C8.75,20.5187829 7.51878306,21.75 6,21.75 L5,21.75 C3.48121694,21.75 2.25,20.5187829 2.25,18.9999999 Z M3.75,14.7499999 L3.75,18.9999999 C3.75,19.6903558 4.30964406,20.2499999 5,20.2499999 L6,20.2499999 C6.69035594,20.2499999 7.25,19.6903558 7.25,18.9999999 L7.25,15.9999999 C7.25,15.3096439 6.69035594,14.7499999 6,14.7499999 L3.75,14.7499999 Z M20.25,14.7499999 L18,14.7499999 C17.3096441,14.7499999 16.75,15.3096439 16.75,15.9999999 L16.75,18.9999999 C16.75,19.6903558 17.3096441,20.2499999 18,20.2499999 L19,20.2499999 C19.6903559,20.2499999 20.25,19.6903558 20.25,18.9999999 L20.25,14.7499999 Z"
  }));
};
export default SvgHeadphones;